import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';

import CircleIcon from './icons/circle_icon';

export default class TransferButton extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }
  render() {
    return (
      <CircleIcon viewBox="0 0 25 25" {...this.props}>
        <g id="iconTransfer">
          <path d="M6.5 17s1.223-6.96 7.05-6.96V7l4.95 5.165-4.893 4.52v-3.546S10.987 11.556 6.5 17" />
        </g>
      </CircleIcon>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/phone_controls/buttons/transfer_button.jsx